import React from "react";
import { EntryTypeInput, EntryTypeInputValue } from "guestlist/EntryTypeInput";
import GuestlistAccessTypeSpotsDropdown from "components/dropdowns/reactselect/GuestlistAccessTypeSpotsDropdown";
import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import { RenderEditOptions } from "components/MainSectionTemplate/types";

interface AccessTypeFormState {
  quantity: number;
  entryType: EntryTypeInputValue;
}

interface Props {
  list: server.dto.GuestlistList;
}

export const AccessTypeSidePanelDetails = (props: Props) => {
  const [formState, setFormState] = React.useState<AccessTypeFormState>({
    quantity: props.list.quantity,
    entryType: {
      entryType: serverReference.guestlistEntryTypes.find(et => et.value === props.list.entryType),
      customLabel: props.list.entryTypeCustomName,
    }
  });

  const onValueChanged = (key: string, value: any) => {
    if (key === "quantity") {
      setFormState((prevState) => ({
        ...prevState,
        quantity: value,
      }));
    } else if (key === "entryType") {
      setFormState((prevState) => ({
        ...prevState,
        entryType: value,
      }));
    }
  }

  const getUpdateInstruction = (state: AccessTypeFormState): server.dto.UpdateGuestlistAccessTypeInstruction => ({
    guestlistAccessTypeId: props.list.guestlistAccessTypeId,
    quantity: state.quantity,
    entryType: state.entryType.entryType.value,
    entryTypeCustomName: state.entryType.customLabel,
  });

  return <SidePanelDetailSectionTemplate
    isInPageEditable
    onValueChanged={onValueChanged}
    fields={[{
      key: "settings",
      type: "regular",
      title: RESX.Guestlist.List,
      fields: [{
        key: "quantity",
        label: RESX.GeneralLabels.Available,
        render: () => <span>{`${formState.quantity} PAX`}</span>,
        inPageEdit: {
          render: ({ value, onChange, cancel }) => <GuestlistAccessTypeSpotsDropdown
            options={[]}
            value={value}
            onChange={(quantity) => {
              onChange(quantity, true);
            }}
            onEsc={() => cancel()}
            config={{
              focusOnMount: true,
              openMenuOnFocus: true,
            }}
          />,
          fullWidth: true,
          type: "custom",
          initialValue: formState.quantity,
          submitChange: (quantity: number) => window.CoreApi.Guestlist.UpdateGuestlistAccessType({
            ...getUpdateInstruction({ ...formState, quantity: quantity }),
          }),
        },
      }, {
        key: "entryType",
        label: RESX.GeneralLabels.Type,
        render: () => <>{formState.entryType.entryType.value === "other" ? formState.entryType.customLabel : formState.entryType.entryType.text}</>,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }: RenderEditOptions<EntryTypeInputValue>) => <EntryTypeInput
            value={value}
            focusOnMount
            validatorKey="entryType"
            onChange={(v, save) => onChange(v, save)}
            cancel={cancel}
            submit={submit}
          />,
          fullWidth: true,
          type: "custom",
          initialValue: formState.entryType,
          submitChange: (value: EntryTypeInputValue) => window.CoreApi.Guestlist.UpdateGuestlistAccessType(
            getUpdateInstruction({
              ...formState,
              entryType: value,
            }),
          ),
        }
      }]
    }]}
  />
}